// ===================================================
// File: src/hooks/useConfirmModal.js
// ===================================================
import { useState } from 'react';

const useConfirmModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    confirmButtonClass: 'btn-primary',
    icon: 'fas fa-question-circle text-warning',
    onConfirm: () => {},
    onCancel: () => {}
  });

  const showConfirm = (config) => {
    setModalState({
      isOpen: true,
      title: config.title || 'Confirm Action',
      message: config.message || 'Are you sure you want to perform this action?',
      confirmText: config.confirmText || 'Confirm',
      cancelText: config.cancelText || 'Cancel',
      confirmButtonClass: config.confirmButtonClass || 'btn-primary',
      icon: config.icon || 'fas fa-question-circle text-warning',
      onConfirm: config.onConfirm || (() => {}),
      onCancel: config.onCancel || (() => {})
    });
  };

  const hideConfirm = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  const handleConfirm = () => {
    modalState.onConfirm();
    hideConfirm();
  };

  const handleCancel = () => {
    modalState.onCancel();
    hideConfirm();
  };

  return { modalState, showConfirm, handleConfirm, handleCancel,hideConfirm   };
};

export default useConfirmModal;